import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-produktgruppe-list-view',
  imports: [],
  templateUrl: './produktgruppe.list-view.html',
  styleUrls: ['./produktgruppe.list-view.css'],
})
export class ProduktgruppeListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
